export default "__VITE_ASSET__e50442be__"